var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDaoCategoryCommunity = function SvgDaoCategoryCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "social-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.894,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.417 16.093a.739.739 0 0 1-.947-.43L12.97.992a.736.736 0 0 1 1.378-.515l1.627 4.343 2.516 6.714 1.354 3.614a.734.734 0 0 1-.431.945Zm-12.174-.076-.771.288-.633.236 1.913 3.111a.735.735 0 0 0 1.254-.768Zm-2.6-7.344-3.578 1.335a1.638 1.638 0 0 0-.962 2.107l1.342 3.582a1.647 1.647 0 0 0 2.111.96l3.578-1.335Zm.608-.347 2.571 6.859 9.827.257-5.151-13.745Zm13.6 2.19a3.475 3.475 0 0 0-2.207-5.889l1.376 3.671Z",
    fillRule: "evenodd"
  })));
};
export default SvgDaoCategoryCommunity;